import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface Props {
  /** The tool's own control: its icon button. */
  children: ReactNode;
  /** The way out, attached while the tool is in use; none draws the icon alone. */
  action?: {
    /** One short word ("Done", "Exit"). */
    label: string;
    /** The tooltip, naming the key that does the same. */
    hint: string;
    onClick: () => void;
  } | null;
}

// A tool's icon with the way out of its mode attached, drawn as one control:
// what ends counting or compare sits on the button that started it. The icon
// stays in the same place in the tree either way, so arming the tool does not
// remount it.
export function AttachedAction({ children, action }: Props) {
  if (!action) return <div className="inline-flex">{children}</div>;
  return (
    <div className="mx-0.5 inline-flex h-8 items-center rounded-md bg-accent pr-1">
      {children}
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={action.onClick}
            className="inline-flex h-6 items-center rounded bg-primary px-2 text-xs font-semibold text-primary-foreground transition-colors hover:bg-primary/85"
          >
            {action.label}
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">{action.hint}</TooltipContent>
      </Tooltip>
    </div>
  );
}
